/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Hero_Or_JsonInputs */

const en_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or JSON`)
};

const zh_hans1_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或 JSON`)
};

const pt_br2_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou JSON`)
};

const es_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o JSON`)
};

const fr_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou JSON`)
};

const de_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder JSON`)
};

const ru_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или JSON`)
};

const it_endpoint_hero_or_json = /** @type {(inputs: Endpoint_Hero_Or_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o JSON`)
};

/**
* | output |
* | --- |
* | "or JSON" |
*
* @param {Endpoint_Hero_Or_JsonInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_hero_or_json = /** @type {((inputs?: Endpoint_Hero_Or_JsonInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Hero_Or_JsonInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_hero_or_json(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_hero_or_json(inputs)
	if (locale === "es") return es_endpoint_hero_or_json(inputs)
	if (locale === "fr") return fr_endpoint_hero_or_json(inputs)
	if (locale === "de") return de_endpoint_hero_or_json(inputs)
	if (locale === "ru") return ru_endpoint_hero_or_json(inputs)
	if (locale === "it") return it_endpoint_hero_or_json(inputs)
	return en_endpoint_hero_or_json(inputs)
});